import { Divider, Grid, Typography } from '@mui/material';
import { IEquipmentSingleOrder } from 'API';
import { ListDivider } from 'Components';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { EquipmentItem } from './EquipmentItem';

interface IEquipmentListProps {
  orderItems: IEquipmentSingleOrder[];
  orderPeriod: string;
}

export const EquipmentList = ({
  orderItems,
  orderPeriod,
}: IEquipmentListProps) => {
  const isDesktop = useIsDesktop();
  const dictionary = useDictionary(Dictionary, DICTIONARY.Equipment);

  return isDesktop ? (
    <>
      <Typography component='h3' tabIndex={0} sx={{ mb: 1 }}>
        {`${dictionary.orderSummaryDialog.summaryOrderItems} ${orderItems.length} ${dictionary.orderSummaryDialog.items}, ${dictionary.orderSummaryDialog.forPeriod}
            ${orderPeriod}`}
      </Typography>
      <Typography tabIndex={0} variant='body6'>
        {dictionary.orderSummaryDialog.subtitle}
      </Typography>

      {orderItems.length > 0 && (
        <>
          <Grid container direction={'column'} mt={3}>
            <Grid container item mb={2}>
              <Grid item xs={6} md={5}>
                <Typography>{dictionary.orderDialog.itemName}</Typography>
              </Grid>

              <Grid container item xs={6} md={7}>
                <Grid
                  container
                  item
                  justifyContent={'start'}
                  sx={{
                    maxWidth: '80px',

                    margin: '10px',
                  }}
                >
                  <Typography>{dictionary.orderDialog.quantity}</Typography>
                </Grid>

                <Grid
                  container
                  item
                  xs={6}
                  md={7}
                  alignContent={'center'}
                  p={'0 24px'}
                >
                  <Typography>{dictionary.orderDialog.notes}</Typography>
                </Grid>
              </Grid>
            </Grid>

            <ListDivider />
            {orderItems.map((item) => (
              <EquipmentItem key={item.itemCatalogNumber} item={item} />
            ))}
          </Grid>
        </>
      )}
    </>
  ) : (
    <>
      <Divider
        aria-hidden='true'
        sx={{ m: '0 0 36px 0', borderColor: 'primary.shade_200' }}
      />
      {orderItems.length > 0 && (
        <>
          <Typography variant='h5' mb={1}>
            {`${dictionary.orderSummaryDialog.summaryOrderItems} ${orderItems.length} ${dictionary.orderSummaryDialog.items}, ${dictionary.orderSummaryDialog.forPeriod}
            ${orderPeriod}`}
          </Typography>
          <Typography variant='body3'>
            {dictionary.orderSummaryDialog.subtitle}
          </Typography>
          <Grid
            container
            direction={'column'}
            mt={3}
            mb={isDesktop ? undefined : 2}
          >
            {orderItems.map((item) => (
              <EquipmentItem key={item.itemCatalogNumber} item={item} />
            ))}
          </Grid>
        </>
      )}
    </>
  );
};
